import { CodeLanguage } from '../../../types';
import { getUnifiedCodeLanguageId } from '../../../utils/getUnifiedCodeLanguageId';

export const getCodeBlockInformation = (
  className?: string,
): [language: CodeLanguage | string, title: string] => {
  if (!className) return ['bash', ''];
  const langMatch = className.match(/language-([^:\s]*)/);
  const titleMatch = className.match(/:title=['"]([^\s]+)['"]/);

  const lang = langMatch ? (langMatch[1] as CodeLanguage) : 'bash';
  const title = titleMatch ? titleMatch[1] : '';

  return [getUnifiedCodeLanguageId(lang), title];
};
